import { isFunction } from "lodash";
import React, { ReactNode } from "react";
import { DragDropContext, Draggable, Droppable, DropResult as Result, ResponderProvided } from "react-beautiful-dnd";
import DraggableRow from "./DraggableRow";
import DraggableRowButtons from "./DraggableRowButtons";
import DraggableRowContent from "./DraggableRowContent";
import { DraggableRowDelete } from "./DraggableRowDelete";
import { DraggableRowHandle } from "./DraggableRowHandle";

export interface DragAndDropProps {
	onDragEnd: (result: DropResult, provided: ResponderProvided) => void;
	className?: string;
	children?: ReactNode;
}

export interface DragAndDropState {}

export interface DragAndDropContext<T = any> {
	extraData: DragAndDropState;
}

export interface DropResult extends Result {}

class DragAndDrop extends React.Component<DragAndDropProps, DragAndDropState> {
	static Draggable = Draggable;
	static DraggableRow = DraggableRow;
	static DraggableRowButtons = DraggableRowButtons;
	static DraggableRowContent = DraggableRowContent;
	static DraggableRowHandle = DraggableRowHandle;
	static DraggableRowDelete = DraggableRowDelete;

	render() {
		const { children, onDragEnd, className, ...otherProps } = this.props;

		return (
			<DragDropContext onDragEnd={onDragEnd} {...otherProps}>
				<Droppable droppableId="droppable">
					{(provided, snapshot) => (
						<div
							{...provided.droppableProps}
							ref={provided.innerRef}
							className={`droppable ${snapshot.isDraggingOver ? "is-dragging-over" : ""} ${className ||
								""}`}
						>
							{isFunction(children)
								? children({
										provided,
										snapshot,
								  })
								: children}
							{provided.placeholder}
						</div>
					)}
				</Droppable>
			</DragDropContext>
		);
	}
}

export default DragAndDrop;
